import { create } from "zustand";
import { StateWithCities } from "../components/interfaces";
import { API } from "../utils/axios";

interface MetaDataStore {
  states: StateWithCities[];
  loading: boolean;
  fetchMetaData: () => Promise<void>;
  getCitiesByState: (stateId: number) => StateWithCities["cities"];
}

export const useMetaDataStore = create<MetaDataStore>((set, get) => ({
  states: [],
  loading: false,

  fetchMetaData: async () => {
    try {
      set({ loading: true });

      const res = await API.get<{ data: StateWithCities[] }>(
        '/business/fetch'
      );

      set({
        states: res.data.data,
        loading: false,
      });
    } catch (error) {
      console.error("Meta fetch error:", error);
      set({ loading: false });
    }
  },

  getCitiesByState: (stateId) => {
    const state = get().states.find((s) => s.zone_id === stateId);
    return state?.cities ?? [];
  },
}));
